import 'react-datepicker/dist/react-datepicker.css';
import React, { Component } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  TabContent,
  TabPane,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { MDBDataTable } from 'mdbreact';

import './datatables.scss';
import { contractProposals, dictAliases } from '../../helpers/api';
import { truncStringPortion } from '../../helpers/formatter.js';
import CSV from '../../components/Common/CSV';
import SVGLogo from '../../components/Common/SVGLogo.js';

class MinterProposals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      decimals: 1000000,
      startDate: new Date(),
      activeTab: '1',
      aliases: [],
      csvRows: [],
      transactions: {
        columns: [
          {
            label: 'Proposal ID',
            field: 'proposalId',
            sort: 'asc',
            width: 136,
          },
          {
            label: 'Proposal Type',
            field: 'proposalType',
            sort: 'asc',
            width: 136,
          },
          {
            label: 'Date',
            field: 'date',
            sort: 'desc',
            width: 136,
          },
          {
            label: 'Address',
            field: 'address',
            width: 160,
          },
          {
            label: 'Amount',
            field: 'amount',
            width: 160,
          },
          {
            label: 'Approvals',
            field: 'approvals',
            sort: 'asc',
            width: 104,
          },
          {
            label: 'Rejects',
            field: 'rejects',
            sort: 'asc',
            width: 104,
          },
          {
            label: 'Status',
            field: 'status',
            sort: 'asc',
            width: 104,
          },
          {
            label: 'Actions',
            field: 'action',
            sort: 'asc',
            width: 100,
          },
        ],
        rows: [],
      },
      limit: false,
      loading: true,
    };
    this.toggleTab = this.toggleTab.bind(this);
    this.handleChange.bind(this);
  }

  handleChange = (date) => {
    this.setState({
      startDate: date,
    });
  };

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  componentDidMount = () => {
    this._asyncRequest = dictAliases()
      .then((res) => {
        if (res.status === 'SUCCESS') {
          this.setState({ aliases: res.data });
        } else {
          console.log(res.error);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    this._asyncRequest = contractProposals('minter')
      .then((res) => {
        if (res.status === 'SUCCESS') {
          for (let proposal of res.data) {
            const rejects =
              proposal.value.ctrlRejects.length +
              proposal.value.opRejects.length;
            const accepts =
              proposal.value.ctrlApprovals.length +
              proposal.value.opApprovals.length;
            let row = {
              proposalId: proposal.key,
              proposalType: proposal.value.operation,
              date: proposal.time,
              address:
                this.state.aliases[proposal.value.address] &&
                this.state.aliases[proposal.value.address].name
                  ? this.state.aliases[proposal.value.address].name
                  : proposal.value.address,
              amount: (
                <span>
                  {parseFloat(proposal.value.amount / this.state.decimals)}{' '}
                  <SVGLogo width="13" height="13" />
                </span>
              ),
              approvals: (
                <span className="badge font-size-9 text-left">
                  {proposal.value.opApprovals.map((approval) => (
                    <div key={approval} className="mt-1">
                      {this.state.aliases[approval] &&
                      this.state.aliases[approval].name
                        ? this.state.aliases[approval].name
                        : truncStringPortion(approval, 8, 6)}
                    </div>
                  ))}{' '}
                  {proposal.value.ctrlApprovals.map((approval) => (
                    <div key={approval} className="mt-1">
                      {this.state.aliases[approval] &&
                      this.state.aliases[approval].name
                        ? this.state.aliases[approval].name
                        : truncStringPortion(approval, 8, 6)}
                    </div>
                  ))}
                </span>
              ),
              rejects: (
                <span className="badge font-size-9 text-left">
                  {proposal.value.opRejects.map((reject) => (
                    <div key={reject} className="mt-1">
                      {this.state.aliases[reject] &&
                      this.state.aliases[reject].name
                        ? this.state.aliases[reject].name
                        : truncStringPortion(reject, 8, 6)}
                    </div>
                  ))}{' '}
                  {proposal.value.ctrlRejects.map((reject) => (
                    <div key={reject} className="mt-1">
                      {this.state.aliases[reject] &&
                      this.state.aliases[reject].name
                        ? this.state.aliases[reject].name
                        : truncStringPortion(reject, 8, 6)}
                    </div>
                  ))}
                </span>
              ),
              status: (
                <b>
                  {proposal.value.status.toString() === 'true'
                    ? 'Closed'
                    : 'Pending'}
                  <br />
                  {proposal.value.status.toString() === 'true' &&
                    rejects > 0 && (
                      <span className="badge badge-danger font-size-10">
                        Rejected
                      </span>
                    )}
                  {proposal.value.status.toString() === 'true' &&
                    accepts > rejects && (
                      <span className="badge badge-success font-size-10">
                        Accepted
                      </span>
                    )}
                  {proposal.value.status.toString() === 'false' && (
                    <span className="badge badge-warning font-size-10">
                      Open
                    </span>
                  )}
                </b>
              ),
              action:
                proposal.value.status.toString() === 'true' ? (
                  <Link
                    as="span"
                    className="badge badge-primary font-size-11"
                    style={{ cursor: 'pointer' }}
                    to={`/proposals/minter/proposal-details?bigmap=0&contract=minter&proposalId=${proposal.key}`}
                  >
                    View Details
                  </Link>
                ) : (
                  <Link
                    as="span"
                    className="badge badge-warning font-size-11"
                    style={{ cursor: 'pointer' }}
                    to={`/proposals/minter/proposal-details?bigmap=0&contract=minter&proposalId=${proposal.key}`}
                  >
                    Accept / Reject
                  </Link>
                ),
            };

            let csvRow = {
              proposalId: proposal.key,
              proposalType: proposal.value.operation,
              date: proposal.time,
              address:
                this.state.aliases[proposal.value.address] &&
                this.state.aliases[proposal.value.address].name
                  ? this.state.aliases[proposal.value.address].name
                  : proposal.value.address,
              amount: parseFloat(proposal.value.amount / this.state.decimals),
              approvals:
                proposal.value.opApprovals.map((approval) =>
                  this.state.aliases[approval] &&
                  this.state.aliases[approval].name
                    ? this.state.aliases[approval].name
                    : truncStringPortion(approval, 8, 6),
                ) +
                ' ' +
                proposal.value.ctrlApprovals.map((approval) =>
                  this.state.aliases[approval] &&
                  this.state.aliases[approval].name
                    ? this.state.aliases[approval].name
                    : truncStringPortion(approval, 8, 6),
                ),
              rejects:
                proposal.value.opRejects.map((reject) =>
                  this.state.aliases[reject] && this.state.aliases[reject].name
                    ? this.state.aliases[reject].name
                    : truncStringPortion(reject, 8, 6),
                ) +
                ' ' +
                proposal.value.ctrlRejects.map((reject) =>
                  this.state.aliases[reject] && this.state.aliases[reject].name
                    ? this.state.aliases[reject].name
                    : truncStringPortion(reject, 8, 6),
                ),
              status:
                proposal.value.status.toString() === 'true'
                  ? 'Closed'
                  : 'Pending' + ' ' + proposal.value.status.toString() ===
                      'true' &&
                    rejects > 0 &&
                    'Rejected' + ' ' + proposal.value.status.toString() ===
                      'true' &&
                    accepts > rejects &&
                    'Accepted',
            };

            this.setState({
              transactions: {
                columns: [...this.state.transactions.columns],
                rows: [...this.state.transactions.rows, row],
              },
              csvRows: [...this.state.csvRows, csvRow],
            });
          }
          this.setState({ loading: false });
        } else {
          console.log(res.error);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {!this.state.loading && (
              <Row>
                <Col lg="12">
                  <Card>
                    <CardBody>
                      <h4 className="card-title">Minter proposals</h4>
                      <TabContent
                        activeTab={this.state.activeTab}
                        className="p-3"
                      >
                        <TabPane tabId="1" id="all-order">
                          <MDBDataTable
                            responsive
                            bordered
                            data={this.state.transactions}
                            className="mt-1"
                            hover
                          />
                          <CSV
                            name="Minter_Proposals"
                            transactions={this.state.transactions}
                            csvRows={this.state.csvRows}
                          />
                        </TabPane>
                      </TabContent>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
            {this.state.loading && (
              <div className="text-center my-3">
                <Link to="#" className="text-primary">
                  <i className="bx bx-loader bx-spin font-size-18 align-middle mr-2"></i>{' '}
                  Loading{' '}
                </Link>
              </div>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default MinterProposals;
